<template>
  	<UiModal :title="title" 
	  	:subtitle="getSubtitle" 
		:buttons="buttons"
		@joinVideo="join('video')"
		@joinAudo="join('audio')"
	  	@close="$emit('close')">
		
    	<template v-slot:body>
			<div class="invite-section">
				<div class="invite-section__title">
					Termenii si conditiile
				</div>
				<div class="invite-section__subtitle">
					NEXYO
				</div>
				    <div class="meeting-join__tos" v-dragscroll="!isMobile">
						<p>
						Serviciul de terapie online se adresează tuturor persoanelor cu
						v&acirc;rsta de peste 18 ani.
						</p>
						<p>
						Terapia online vă ofera garanţia confindeţialităţii. Nicio informaţie
						despre clienţi nu va fi facută publică.
						</p>
						<p>
						<span>NU</span> este
						soluția potrivită pentru dvs. dacă vă aflați &icirc;n una dintre
						situațiile următoare:
						</p>
						<ul>
						<li>Aveți g&acirc;nduri de a va răni pe dvs. sau pe ceilalți</li>
						<li>
							Sunteți minor sau sunteți sub &icirc;ngrijirea unui tutore legal
						</li>
						<li>Vă aflați &icirc;ntr-o criză sau &icirc;n situații de urgență</li>
						<li>
							Ați fost diagnosticat cu o boală psihică severă sau vi s-a
							recomandat să vă aflați sub supraveghere sau &icirc;ngrijire
							psihiatrică
						</li>
						<li>
							Vi s-a solicitat consiliere psihologică fie printr-o hotăr&acirc;re
							judecătorească, fie prin altă autoritate
						</li>
						<li>
							Nu aveți un dispozitiv care să se poată conecta la Internet sau nu
							aveți o conexiune de internet fiabilă.
						</li>
						</ul>
						<p>
						- Intervențiile psihologice și de psihoterapie au caracterul unor
						obligații de mijloace , iar nu de rezultat !
						</p>
						<p>
						- Serviciile terapeutice online nu oferă o evaluare clinică şi nu
						garantează vindecarea sau eliminarea problemelor cu care vă
						confruntați !
						</p>
						<p>&nbsp;</p>
						<p>
						- Timpul minim alocat unei şedinţe este de 60 min.
						</p>
						<p>
						- Frecvenţa şedinţelor se prestabileşte de comun acord cu
						specialistul.
						</p>
						<p>
						- Acordul terapeutic se &icirc;ncheie pe minim 4 sedințe.
						</p>
						<p>&nbsp;</p>
						<p>
						<strong
							>&nbsp;- Drepturile şi
							obligaţiile&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong
						>
						</p>
						<ul>
						<li>
							<strong> Beneficiarul</strong> serviciilor psihologice are
							următoarele drepturi şi obligaţii:
						</li>
						<li>
							a) să fie informat cu privire la condiţiile prestării serviciilor
							psihologice ce formează obiectul prezentului contract;
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
						</li>
						<li>
							b) să achite integral preţul serviciilor psihologice ce formează
							obiectul prezentului contract, indiferent de rezultatul acestora,
							prin orice modalitate de plată acceptată de către furnizorul
							serviciului psihologic, la termenul precizat de către acesta prin
							prezentul contract;
						</li>
						<li>
							c) să respecte indicaţiile furnizorului serviciului psihologic şi să
							aibă un comportament civilizat pe toată perioada prestării
							serviciilor psihologice;
						</li>
						<li>
							d) să-şi asume &icirc;n totalitate declaraţia privind
							consimţăm&acirc;ntul informat, potrivit art. 8 din prezentul
							contract.
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
						</li>
						<li>
							<strong> Furnizorul</strong> serviciilor psihologice are următoarele
							drepturi şi obligaţii:
						</li>
						<li>
							a) să &icirc;ntreprindă toate acţiunile pe care le consideră
							necesare &icirc;n realizarea scopului prevăzut &icirc;n obiectul
							contractului;
						</li>
						<li>
							b) să nu fie constr&acirc;ns &icirc;n nici un fel, cu privire la
							modalitatea exercitării profesiei;
						</li>
						<li>
							c) să respecte confidenţialitatea prezentului contract, precum şi
							secretul profesional, potrivit dispoziţiilor art. 46-48 din Normele
							metodologice de aplicare a Legii nr. 213/2004, aprobate prin H.G nr.
							788/2005;
						</li>
						<li>
							d) să elibereze beneficiarului, &icirc;n cel mai scurt timp posibil,
							rezultatul serviciilor psihologice, fără a afecta calitatea
							acestora.
						</li>
						</ul>
					</div>
				<div class="invite-section__disclaimer">
					*Prin participarea la sedinta va exprimati acordul asupra termenilor si conditiilor platformei.
				</div>
			</div>
    	</template>
  	</UiModal>
</template>

<script>

import UiModal from "@/components/ui/Modal";
import { mapGetters } from 'vuex'
	
export default {
  	components: { UiModal },
	data() {
		return {
			title: '',
			subtitle: '',
			buttons: [],
			joinToken: null,
			queueChannel: null
		};
	},
	props: {
		minutes: {
			type: [String, Number],
			default: null
		},
		seconds: {
			type: [String, Number],
			default: null
		}
	},
	mounted() {
		this.title = 'Intră în ședință acum';
		// this.subtitle = 'Invitația mai este valabilă: XX secunde';
		this.buttons = [
			{ event: "joinVideo", text: "Intra cu video", style: "gradient" },
			{ event: "joinAudo", text: "Intra cu audio" }
		];
				
		if(this.anytimeWidget.user.role == 'client')
			this.joinToken = this.anytimeWidget.meeting.client_token;
		else
			this.joinToken = this.anytimeWidget.meeting.specialist_token;
		
		//I.Create queue channel string {{specialistId_specialistFullName_queue}}
		this.queueChannel = this.anytimeWidget.otherUser.id + '_' + (this.anytimeWidget.otherUser.full_name).replace(/\s/g, '','') + '_queue';

		//II.Subscribe to queue channel for incoming data
		this.sockets.subscribe(this.queueChannel, data => {
			switch (data.event){
				case 'meeting':
					this.joinToken = data.token;
					this.status = 'join';
					break;
			}

		});
	},
	destroyed() {
		this.title = ''; this.subtitle = ''; this.buttons = [];
	},
	computed: {
		...mapGetters({
			user: 'user/user',
			specialist: 'specialist/specialist',
			isMobile: 'layout/isMobile',
			anytimeWidget: 'layout/anytimeWidget'
		}),
		getSubtitle() {		
			var text = '';
			if(this.minutes >= 2)
				text = 'Ședința se va încheia în: '+this.minutes+' minute și '+this.seconds+' secunde';
			else if(this.minutes == 1) 
				text = 'Ședința se va încheia într-un minut și'+this.seconds+' secunde';
			else if(this.minutes == 0) 
				text = 'Ședința se va încheia în '+this.seconds+' secunde';
			return text;
		}
	},
	methods: {
		join(method) {
			this.$emit('close');			
			
			let meetingUrl = "/anytime-meetingroom?token=" + this.joinToken + "&joinVideo=" + (method == "video" ? "true" : "false"); 
			this.$router.push(meetingUrl);
		}
	}
}
</script>

<style lang="scss" scoped>
.invite-section {
	margin-top: 30px;
	
	&__title {
		font-family: 'DIN Pro', sans-serif;
		font-style: normal;
		font-weight: 500;
		font-size: 18px;
		line-height: 20px;
		text-align: center;
		color: $color-gray;
	}
	
	&__subtitle {
		font-family: 'DIN Pro', sans-serif;
		font-style: normal;
		font-weight: 500;
		font-size: 18px;
		line-height: 20px;
		text-align: center;
		color: $color-primary;
		margin: 5px;
		margin-bottom: 20px;
	}
	
	&__content {
		height: 140px;
		overflow-y: scroll;
		padding: 10px;
		margin: 0 10px;
		background: #FFFFFF;
		box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.06);
		
		font-family: 'DIN Pro', sans-serif;
		font-style: normal;
		font-weight: normal;
		font-size: 16px;
		line-height: 20px;
	}
	
	&__disclaimer {
		font-family: 'Roboto', sans-serif;
		font-style: normal;
		font-weight: normal;
		font-size: 14px;
		line-height: 20px;
		color: rgba(55, 52, 53, 0.7);
		margin: 20px 10px;
	}
}

.meeting-join {
  &__tos {
    padding: 0px 10px;
    font-size: 16px;
    line-height: 20px;
    // box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.06);
    box-shadow: 0 3px 3px -2px rgba(0, 0, 0, 0.2),
      0 3px 4px 0 rgba(0, 0, 0, 0.14), 0 1px 8px 0 rgba(0, 0, 0, 0.12);
    max-width: 95%;
    margin: 25px auto 0px auto;
    overflow-y: auto;
    max-height: 250px;
    text-align: justify;
    cursor: grab;

    &:active{
        cursor: grabbing;
    }

    &> p{
        display: block; margin-top: 1em; margin-bottom: 1em; margin-left: 0; margin-right: 0;
        line-height: 1.2em;    
        text-align: left;
    }

    &> ul{
        list-style-type: circle;

        &> li{
            margin: 10px 0;
        }
    }

  }

  &__tos::-webkit-scrollbar {
    display: none;
  }

  &__info {
    margin-bottom: 20px;
  }
}

.expire-section {
	min-height: 20vh;
	font-family: 'DIN Pro', sans-serif;
	font-style: normal;
	font-weight: 500;
	font-size: 18px;
	line-height: 20px;
	text-align: center;
	color: #373435;
	display: flex;
	align-items: center;
	justify-content: center;
}

.generate-section {
	min-height: 20vh;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	
	&__title {
		width: 100%;
		font-family: 'DIN Pro', sans-serif;
		font-style: normal;
		font-weight: 500;
		font-size: 18px;
		line-height: 20px;
		text-align: center;
		color: #373435;
		margin: 10px;
	}
	
	&__icon {
		margin: 10px;
		color: $color-warning;
	}
}

.accept-section {
	min-height: 20vh;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	
	&__title {
		width: 100%;
		font-family: 'DIN Pro', sans-serif;
		font-style: normal;
		font-weight: 500;
		font-size: 18px;
		line-height: 20px;
		text-align: center;
		color: #373435;
		margin: 10px;
	}
	
	&__icon {
		margin: 10px;
		color: $color-secondary;
	}
}
</style>